import React, { Fragment } from "react";
import { useTranslation } from "react-i18next";
import { Container, Row } from "reactstrap";
import { Breadcrumbs } from "../../AbstractElements";
import { Col } from "react-bootstrap";
import SampleHome from "./SampleHome";

export default function SampleList() {
    const { t } = useTranslation();
    return (
        <Fragment>
            <Breadcrumbs mainTitle={t("List of Samples")} parent={t("Home")} title={t("List of Samples")} />
            <Container fluid={true}>
                <Row>
                    <Col className="h-100">
                        <SampleHome />
                    </Col>
                </Row>
            </Container>
        </Fragment>
    )
}
